import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

type Theme = 'dark' | 'light';
const Ctx = createContext<{ theme: Theme; setTheme: (t: Theme) => void } | null>(null);

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, set] = useState<Theme>(() => (localStorage.getItem('stanwars.theme') as Theme | null) ?? 'dark');
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem('stanwars.theme', theme);
  }, [theme]);
  return <Ctx.Provider value={{ theme, setTheme: set }}>{children}</Ctx.Provider>;
}

export function useTheme(): { theme: Theme; setTheme: (t: Theme) => void } {
  const v = useContext(Ctx);
  if (!v) throw new Error('useTheme outside provider');
  return v;
}
